import { CLASS_ASIDE_PANEL } from '../../constants';

export const CLASS_ASIDE_PANEL_FOOTER = CLASS_ASIDE_PANEL + '__footer';
